module.exports = __webpack_public_path__ + "static/media/masters_thesis11.1d4d9b47.webp";